export const OFFLINE_DEVICE_APPROVAL_PENDING_LABEL = "Offline App: Device Approval Pending";